/* global search_vars */

import StuurluiAlgolia, { bindOverviewSearchboxWcag } from '~/js/components/algolia.js';
import { connectStats } from 'instantsearch.js/es/connectors';
import { currentRefinements, menu } from 'instantsearch.js/es/widgets';
import { defaultCard } from '../../partials/algolia-cards/default-card';
import { faqCard } from '../../partials/algolia-cards/faq-card';

const SEARCH_TYPE_ATTR = 'post_type';
const SEARCH_STATUS_ATTR = 'tax_status_slug';
function strl_escape_html(str) {
	const el = document.createElement('div');
	el.textContent = str;
	return el.innerHTML;
}

function strl_escape_attr(str) {
	return String(str).replace(/&/g, '&amp;').replace(/"/g, '&quot;');
}

function strl_search_hit_template(hit, helpers) {
	if (hit.post_type === 'faq') {
		return faqCard(hit, helpers.html, helpers.components);
	}
	return defaultCard(hit, helpers.html, helpers.components);
}

function strl_search_refinement_pill(label, onRemove) {
	const iconHtml = onRemove
		? `<button type="button" class="search__refinement-remove ml-1 border-0 bg-transparent p-0" aria-label="${strl_escape_attr(strl_vars.search_label)}">
				<i class="fa-regular fa-xmark text-sm" aria-hidden="true"></i>
			</button>`
		: '';

	return `<span class="pill">
		<span>${strl_escape_html(label)}</span>${iconHtml}
	</span>`;
}

function strl_search_update_status_buttons(activeStatus) {
	const buttons = document.querySelectorAll('.search__status-btn');
	for (let i = 0; i < buttons.length; i++) {
		const btn = buttons[i];
		const isActive = btn.dataset.status === activeStatus;
		btn.classList.toggle('search__status-btn--active', isActive);
		btn.classList.toggle('border-primary', isActive);
		btn.classList.toggle('border-primary/25', !isActive);
	}
}

function strl_search_set_status(algolia, statusSlug, statusSlugs, baseFilters) {
	const helper = algolia.search.helper;
	helper.setQueryParameter(
		'filters',
		strl_search_build_filters(baseFilters, statusSlug, statusSlugs)
	);
	helper.search();
	strl_search_update_status_buttons(statusSlug);
}

function strl_search_bind_status_toggle(algolia, statusSlugs, baseFilters) {
	const actueelBtn = document.getElementById('search-status-actueel');
	const archiveBtn = document.getElementById('search-status-archive');

	if (actueelBtn && !actueelBtn.dataset.strlBound) {
		actueelBtn.dataset.strlBound = '1';
		actueelBtn.addEventListener('click', () => {
			strl_search_set_status(algolia, statusSlugs.actueel, statusSlugs, baseFilters);
		});
	}
	if (archiveBtn && !archiveBtn.dataset.strlBound) {
		archiveBtn.dataset.strlBound = '1';
		archiveBtn.addEventListener('click', () => {
			strl_search_set_status(algolia, statusSlugs.archive, statusSlugs, baseFilters);
		});
	}
}

function strl_search_update_query_refinement(algolia, keywordLabel) {
	const queryEl = document.getElementById('search-query-refinement');
	const filteredOnEl = document.getElementById('search-filtered-on');
	if (!queryEl) {
		return;
	}

	const query = algolia.search.helper.state.query || '';
	if (!query) {
		queryEl.innerHTML = '';
		queryEl.classList.add('hidden');
		return;
	}

	queryEl.innerHTML = strl_search_refinement_pill(keywordLabel, true);
	queryEl.classList.remove('hidden');
	filteredOnEl?.classList.remove('hidden');

	if (!queryEl.dataset.strlBound) {
		queryEl.dataset.strlBound = '1';
		queryEl.addEventListener('click', (event) => {
			if (!event.target.closest('.search__refinement-remove')) {
				return;
			}
			algolia.search.helper.setQuery('').search();
		});
	}
}

function strl_search_update_filtered_on_visibility(algolia) {
	const filteredOnEl = document.getElementById('search-filtered-on');
	if (!filteredOnEl) {
		return;
	}

	const query = algolia.search.helper.state.query || '';
	const refinements = algolia.search.helper.state.disjunctiveFacetsRefinements || {};
	const refinementList = algolia.search.helper.state.facetsRefinements || {};
	let hasRefinements = false;

	Object.keys(refinements).forEach((key) => {
		if (key !== SEARCH_STATUS_ATTR && refinements[key] && refinements[key].length > 0) {
			hasRefinements = true;
		}
	});
	Object.keys(refinementList).forEach((key) => {
		if (key !== SEARCH_STATUS_ATTR && refinementList[key] && refinementList[key].length > 0) {
			hasRefinements = true;
		}
	});

	if (query || hasRefinements) {
		filteredOnEl.classList.remove('hidden');
	} else {
		filteredOnEl.classList.add('hidden');
	}
}

if (typeof search_vars !== 'undefined' && search_vars.index_name) {
	try {
		const i18n = search_vars.i18n || {};
		const statusSlugs = search_vars.status_slug || {
			actueel: 'actueel',
			archive: 'archive',
		};

		const algolia = new StuurluiAlgolia(
			search_vars.index_name,
			strl_vars.algolia_api_key,
			strl_vars.algolia_app_id
		);

		await algolia.init([]);

		const typeFilterLabel =
			i18n.type_filter_label && String(i18n.type_filter_label)
				? String(i18n.type_filter_label)
				: 'Type';
		const searchSubmitLabel =
			i18n.search_submit && String(i18n.search_submit) ? String(i18n.search_submit) : 'Search';
		const keywordLabel = i18n.keyword && String(i18n.keyword) ? String(i18n.keyword) : 'Keyword';
		const noResultsText =
			i18n.no_results && String(i18n.no_results) ? String(i18n.no_results) : 'No results found.';

		const renderStats = (renderOptions) => {
			const el = document.getElementById('search-stats');
			if (!el) {
				return;
			}
			const { nbHits } = renderOptions;
			const resultsLabel = i18n.results ? String(i18n.results) : 'results';
			const oneResultLabel = i18n.one_result ? String(i18n.one_result) : 'result';
			if (nbHits === 1) {
				el.textContent = `1 ${oneResultLabel}.`;
				return;
			}
			el.textContent = `${nbHits} ${resultsLabel}.`;
		};

		const customStats = connectStats(renderStats)({
			container: '#search-stats',
		});

		const baseFilters = search_vars.filters || '';

		const widgets = [
			algolia.setConfig({
				hitsPerPage: 10,
			}),
			algolia.overviewSearchBoxWidget('#search-searchbox', searchSubmitLabel),
			algolia.refinementPanelWidget(
				'',
				{
					container: '#search-type-filter',
					attribute: SEARCH_TYPE_ATTR,
					facetType: 'dropdown',
					cssClasses: {
						root: 'w-full',
						select:
							'overview-select-dropdown',
					},
					templates: {
						defaultOption() {
							return typeFilterLabel;
						},
						item(item) {
							const slug = String(item.value);
							const label = strl_escape_html(
								strl_vars.cpt_labels[slug] || String(item.label)
							);
							const value = strl_escape_attr(slug);
							const selected = item.isRefined ? ' selected' : '';
							return `<option value="${value}"${selected}>${label}</option>`;
						},
					},
				},
				false,
				false,
				999
			),
			customStats,
			currentRefinements({
				container: '#search-current-refinements',
				cssClasses: {
					label: 'hidden',
					// category: 'hidden',
					list: 'inline-flex flex-wrap items-center gap-2 mb-0',
					item: 'inline-flex',
					delete: 'search__refinement-remove ml-1 border-0 bg-transparent p-0',
				},
				transformItems(items) {
					return items
						.filter((item) => item.attribute !== SEARCH_STATUS_ATTR)
						.map((item) => {
							if (item.attribute === SEARCH_TYPE_ATTR) {
								return {
									...item,
									refinements: item.refinements.map((refinement) => ({
										...refinement,
										label:
											strl_vars.cpt_labels[refinement.label] ||
											refinement.label,
									})),
								};
							}
							return item;
						});
				},
			}),
			algolia.hitsWidget(
				{
					empty: (results) => {
						if (results.query === '') {
							return null;
						}
						return `<p class="search__empty text-secondary-140 mb-0">${strl_escape_html(noResultsText)}</p>`;
					},
					item: (hit, helpers) => strl_search_hit_template(hit, helpers),
				},
				'#search-hits',
				{
					list: 'list-none flex flex-col gap-2',
				}
			),
			algolia.customPaginationWidget('#search-pagination', {
				cssClasses: {
					list: 'mb-0 flex list-none items-center justify-center gap-2 p-0',
					link: 'border-primary-40 text-primary flex size-11 items-center justify-center rounded-full border bg-white text-base leading-none font-medium no-underline',
					linkActive:
						'border-primary bg-primary text-white flex size-11 items-center justify-center rounded-full text-base leading-none font-medium no-underline',
					ellipsisSpan:
						'text-primary flex size-11 items-center justify-center text-base leading-none font-medium',
					prevNextLink: 'border-primary',
				},
			}),
			menu({
				container: '#status-toggle',
				cssClasses: {
					list: 'status-toggle',
				},
				attribute: SEARCH_STATUS_ATTR,
				transformItems(items) {
					return items.sort((a, b) => {
						return a.label.localeCompare(b.label);
					});
				}
			}),
		];

		algolia.addWidgets(widgets);
		algolia.start();

		strl_search_update_status_buttons(statusSlugs.actueel);
		strl_search_bind_status_toggle(algolia, statusSlugs, baseFilters);

		algolia.search.on('render', () => {
			bindOverviewSearchboxWcag('search-searchbox');
			strl_search_update_query_refinement(algolia, keywordLabel);
			strl_search_update_filtered_on_visibility(algolia);

			const refinementItems = document.querySelectorAll(
				'#search-current-refinements .ais-CurrentRefinements-item'
			);
			for (let ri = 0; ri < refinementItems.length; ri++) {
				const item = refinementItems[ri];
				if (item.dataset.strlPillStyled === '1') {
					continue;
				}
				item.dataset.strlPillStyled = '1';
				item.classList.add('pill');
			}
		});
		bindOverviewSearchboxWcag('search-searchbox');
	} catch (err) {
		console.error('[search] Algolia init failed:', err);
		const hitsEl = document.querySelector('#search-hits');
		if (hitsEl && search_vars.i18n && search_vars.i18n.load_error) {
			hitsEl.innerHTML = `<p class="search__empty text-secondary-140 mb-0">${strl_escape_html(search_vars.i18n.load_error)}</p>`;
		}
	}
}
